<template>
    <v-container v-if="inputItemCount > 0">
        <span style="font-size: 1.92rem;">あなたの入力項目 </span>
        <span style="color: deeppink; font-size:2.8rem;">{{inputtedCount}}</span>
        <span style="font-size: 1.92rem;"> / {{inputItemCount}}</span>
        <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" style="padding: 0 0 10px 0;">
                    mdi-help-circle
                </v-icon>
            </template>
            <span>
                入力項目を記入して確認ボタンをクリックしてください<br>
                各入力項目をクリックすると該当ページに移動することができます
            </span>
        </v-tooltip>
        <v-card
            v-for="inputItems in Object.entries(this.inputs)"
            :key="'pdf-'+inputItems[0]"
            style="margin-bottom: 10px;"
        >
            <v-card-title>
                {{pdfs[inputItems[0]].filename}}
            </v-card-title>
            <v-list>
                <v-list-item-group
                    color="primary"
                >
                    <template v-for="inputItem in Object.entries(inputItems[1])">
                        <v-list-item
                            v-for="(item, i) in Object.entries(inputItem[1])"
                            :key="'input-'+item[0]"
                        >
                            <v-list-item-icon>
                                <v-icon color="grey">mdi-checkbox-blank-circle</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content @click="inputFocus(inputItems[0], item)">
                                <template v-if="item[1].label">
                                    <v-list-item-title v-text="item[1].label"></v-list-item-title>
                                </template>
                                <template v-else>
                                    <v-list-item-title v-text="inputTypeStr[item[1].type]"></v-list-item-title>
                                </template>
                            </v-list-item-content>
                        </v-list-item>
                    </template>
                </v-list-item-group>
            </v-list>
        </v-card>
    </v-container>
</template>

<script>
    export default {
        props: ['inputs', 'pdfs'],
        data: function () {
            return {
                inputTypeStr: {
                    "text": "フリーテキスト",
                    "select": "セレクトボックス",
                    "checkbox": "チェックボックス",
                    "seal": "押印",
                    "square-seal": "押印"
                },
                inputItemCount: 0,
                inputtedCount: 0,
                notEmptyItems: {}, // 入力済みの項目かどうか {objectid : true/false}
            };
        },
        created: function () {
            Object.entries(this.inputs).forEach(inputItems => {
                Object.entries(inputItems[1]).forEach(inputItem => {
                    this.inputItemCount += Object.entries(inputItem[1]).length;
                    Object.entries(inputItem[1]).forEach(item => {
                        this.notEmptyItems[item[0]] = false;
                        if (item[1]['value'] == 'checked') {
                            this.inputtedCount += 1;
                        }
                    });
                });
            });
            this.inputUpdate(this.inputs);
        },
        computed: {
            inputCount: function () {
                let inputCount = 0;
                Object.keys(this.notEmptyItems).forEach(function (key) {
                    if (this.notEmptyItems[key]) {
                        inputCount++;
                    }
                }, this);
                return inputCount;
                // return Object.values(this.notEmptyItems).filter(item => item).length;
            }
        },
        methods: {
            inputFocus: function (fileId, inputItem) {
                let item =  {
                    'fileId': fileId,
                    'inputItem': inputItem
                };
                this.$emit('inputFocus', item);
            },
            inputUpdate: function (inputs) {
                this.inputtedCount = 0;
                Object.entries(inputs).forEach(inputItems => {
                    Object.entries(inputItems[1]).forEach(inputItem => {
                        // this.inputItemCount += Object.entries(inputItem[1]).length;
                        Object.entries(inputItem[1]).forEach(item => {
                            if (this.notEmptyItems[item[0]] != null && item[1] != null) {
                                // this.notEmptyItems[item[0]] = item[1].value.length > 0;
                                
                                if (item[1].type != null && item[1].type == 'checkbox' && item[1].value == true) {
                                    this.$set(this.notEmptyItems, item[0], true);
                                    this.inputtedCount++;
                                } else if (item[1].type != null && item[1].type == 'checkbox' && item[1].value == false) {
                                    this.$set(this.notEmptyItems, item[0], false);
                                    // this.inputtedCount++;
                                } else {
                                    if (item[1].value != null && (item[1].value.length ?? 0) > 0) {
                                        this.$set(this.notEmptyItems, item[0], true);
                                        this.inputtedCount++;
                                    }
                                    
                                }
                                
                            } else {
                                this.$set(this.notEmptyItems, item[0], false);
                            }
                        }, this);
                    }, this);
                }, this);
            }
        },
    };
</script>

<style scoped>

</style>